import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Container, Form, Button, Spinner, Row, Col, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight, faCheck } from '@fortawesome/free-solid-svg-icons';
import { LanguageProvider } from '../../core/language-provider';
import { LoginManager } from '../../core/login-manager';
import { theme } from '../../config/theme';


export default function Recover() {
    const { blue, lightBlue } = theme;
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [sending, setSending] = useState(false);
    const [showOtpModal, setShowOtpModal] = useState(false);
    const [otp, setOtp] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [verifying, setVerifying] = useState(false);
    const [resending, setResending] = useState(false);

    async function handleSubmit(e) {
        e.preventDefault();
        if (!email || sending) return;
        setSending(true);
        const response = await LoginManager.recoverPassword(email);
        setSending(false);
        if (response.success === 1) {
            setShowOtpModal(true);
        }
    }

    async function handleVerify(e) {
        e?.preventDefault();
        if (!otp || !newPassword || !confirmPassword) return;
        setVerifying(true);
        const res = await LoginManager.resetPassword(otp, newPassword, confirmPassword);
        setVerifying(false);
        if (res.success === 1) {
            setShowOtpModal(false);
            navigate('/login');
        }
    }

    async function handleResend(e) {
        e?.preventDefault();
        if (!email || resending) return;
        setResending(true);
        await LoginManager.recoverPassword(email);
        setResending(false);
    }

    return (
        <>
            <Container fluid>
                <Container fluid={'md'}>
                    {/* Title */}
                    <Row className='pt-5 pb-4'>
                        <Col>
                            <div className='d-flex align-items-center' style={{ color: blue }}>
                                <Link to='/' style={{ color: blue, textDecoration: 'none' }}>
                                    <FontAwesomeIcon icon={faArrowLeft} />
                                    <span className='visually-hidden'>{LanguageProvider.get('pages.jobDetail.back')}</span>
                                </Link>
                                <h2 className='mb-0 ms-3' style={{ color: blue }}>{LanguageProvider.get('pages.recover.title')}</h2>
                            </div>
                        </Col>
                    </Row>

                    {/* Email input */}
                    <Form onSubmit={handleSubmit}>
                        <Row className='align-items-center g-3 mb-3'>
                            <Col md={2} xs={12} className='text-md-start' style={{ color: blue }}>
                                {LanguageProvider.get('pages.recover.emailLabel')}
                            </Col>
                            <Col md={10} xs={12}>
                                <Form.Control
                                    type='email'
                                    placeholder='Email'
                                    value={email}
                                    onChange={e => setEmail(e.target.value)}
                                    required
                                />
                            </Col>
                        </Row>

                        <Row className='mt-2 mb-3'>
                            <Col md={{ span: 10, offset: 2 }} xs={12}>
                                <Button
                                    type='submit'
                                    className='w-100'
                                    style={{ backgroundColor: lightBlue, borderColor: lightBlue }}
                                    disabled={sending || email === ""}
                                >
                                    {sending ? (
                                        <>
                                            {LanguageProvider.get('login.send_forgot_password_key')}
                                            <Spinner size='sm' className='ms-2' />
                                        </>
                                    ) : (
                                        <>
                                            {LanguageProvider.get('pages.recover.sendCode')} <FontAwesomeIcon icon={faArrowRight} className='ms-2' />
                                        </>
                                    )}
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </Container>
            </Container>

            {/* OTP Modal */}
            <Modal show={showOtpModal} onHide={() => setShowOtpModal(false)} centered>
                <Modal.Body className='p-4 p-md-5'>
                    <h2 className='fw-bold mb-3' style={{ color: blue, lineHeight: 1.2 }}>
                        {LanguageProvider.get('pages.recover.otpTitle')}
                    </h2>
                    <div className='mb-4' style={{ color: blue }}>
                        {LanguageProvider.get('pages.recover.otpDesc')}
                    </div>

                    <Form onSubmit={handleVerify}>
                        <Form.Control
                            className='mb-2'
                            placeholder={LanguageProvider.get('pages.recover.otpPlaceholder')}
                            value={otp}
                            onChange={e => setOtp(e.target.value)}
                        />
                        <div className='mb-3'>
                            <Button variant='link' className='p-0' style={{ color: lightBlue }} onClick={handleResend} disabled={resending}>
                                {resending ? LanguageProvider.get('pages.recover.verifying') : LanguageProvider.get('pages.recover.resendOtp')}
                            </Button>
                        </div>

                        {/* New password fields */}
                        <Form.Control
                            type='password'
                            className='mb-2'
                            placeholder={LanguageProvider.get('pages.recover.newPassword')}
                            value={newPassword}
                            onChange={e => setNewPassword(e.target.value)}
                        />
                        <Form.Control
                            type='password'
                            className='mb-4'
                            placeholder={LanguageProvider.get('pages.recover.confirmPassword')}
                            value={confirmPassword}
                            onChange={e => setConfirmPassword(e.target.value)}
                        />

                        <Button
                            type='submit'
                            className='w-100'
                            style={{ backgroundColor: lightBlue, borderColor: lightBlue }}
                            disabled={verifying || !otp || !newPassword || !confirmPassword}
                        >
                            {verifying ? LanguageProvider.get('pages.recover.verifying') : (
                                <>
                                    {LanguageProvider.get('pages.recover.verify')} <FontAwesomeIcon icon={faCheck} className='ms-1' />
                                </>
                            )}
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    );
};
